import { FC, useCallback, useEffect, useState } from "react";
import _ from "lodash";

import ComputerIcon from "@mui/icons-material/Computer";
import { Box } from "@mui/material";
import Carousel from "components/carousel/Carousel";
import CategorySectionCreator from "components/CategorySectionCreator";

import useWindowSize from "hooks/useWindowSize";

import { ProductsSkeleton } from "components/skeletons";
import { PcBundleData } from "modules/pc-bundle";
import { PcBundleCard } from "components/product-cards/PcBundleCard";
import { useRouter } from "next/router";

type Props = {
  productBundles?: PcBundleData[];
  isBundlesLoading?: boolean;
};

const ProductBundlesCarousel: FC<Props> = ({
  productBundles,
  isBundlesLoading,
}) => {
  const { push } = useRouter();

  const [visibleSlides, setVisibleSlides] = useState(4);
  const width = useWindowSize();

  const onHandleNavigateBundleDetails = useCallback(
    (pc_bundle_id?: string, pc_bundle_slug?: string) => {
      const url = `/pc-bundle/details/${pc_bundle_id}?build=${pc_bundle_slug}`;
      push(url);
    },
    [push]
  );

  useEffect(() => {
    if (width < 650) setVisibleSlides(1);
    else if (width < 750) setVisibleSlides(1.9);
    else if (width < 950) setVisibleSlides(2.1);
    else if (width < 1200) setVisibleSlides(3);
    else setVisibleSlides(3.5);
  }, [width]);

  return (
    <CategorySectionCreator
      sx={{ marginTop: 3 }}
      icon={<ComputerIcon color="secondary" fontSize="small" />}
      title="Powered builds for product."
      titleFontSize="medium"
    >
      {productBundles?.length > 0 ? (
        <Carousel
          showArrow
          spacing={"-0.5rem"}
          infinite={false}
          showArrowOnHover
          totalSlides={
            productBundles.length === 1 ? 2 : productBundles.length || 1
          }
          visibleSlides={visibleSlides}
        >
          {productBundles.map((bundle, index) => (
            <Box key={index} sx={{ p: 1 }}>
              <PcBundleCard
                pc_bundle_data={bundle}
                onHandleNavigateDetails={() =>
                  onHandleNavigateBundleDetails(
                    bundle?.pc_bundle_id,
                    bundle?.pc_bundle_slug
                  )
                }
              />
            </Box>
          ))}
          {isBundlesLoading
            ? _.map([1, 2, 3, 4, 5, 6], (item, ind) => (
                <Box sx={{ marginX: 1 }}>
                  <ProductsSkeleton />
                </Box>
              ))
            : null}
        </Carousel>
      ) : null}
    </CategorySectionCreator>
  );
};

export default ProductBundlesCarousel;
